import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const OOMA_PROMO_CODE = "2021OOMAP1"

export const OomaGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(OOMA_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      OOMA_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>
              Enter your T-Mobile Home Internet billing phone number to begin the redemption process, please find your assigned billing phone number on your bill under "connected devices". You will then be prompted to log in to your account.

            </p>
            <img style={{ marginTop: "1rem" }} src={"images/Ooma/ooma_logo.png"} alt="Ooma Logo" className="mb-3" />
            <p>
              T-Mobile Home Internet customers get an Ooma Telo Air FREE (a value of $129.99) when you  sign up for Ooma Premier ($9.99/month) for 18 months.
            </p>

          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-4">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/content/t-mobile/consumer/isp/FAQ.html" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
